module.exports = __webpack_public_path__ + "img/logo.a1b657c6.jpg";